import React from "react";

class NoMatch extends React.Component {
  componentDidMount() {
    // Redirect to the fyp homepage if no design is found
    if (typeof window !== "undefined") {
      window.location.href = process.env.REACT_APP_API_ROOT;
    }
  }

  render() {
    return null;
  }
}

export default NoMatch;
